import { Box, Heading, Card, CardBody, Stack, Table, Tbody, Tr, Td, Th, CardFooter, Text, Thead, useToast, Icon, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { react_api, timer_refresh_upload_status } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import logout from "../services/authService";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import { useNavigate } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { AiFillWarning } from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";

export default function StatusInformations() {
    const { t } = useTranslation();
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState([]);
    const toast = useToast();
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const { updateSessionData, clearSessionData } = useSession();

    const axiosInstance = createAxiosInstance(async (axiosInstance) => {

        logout(t, clearSessionData, navigate, toast, axiosInstance)
    });

    const getStatusIcon = (status_code) => {
        switch (status_code.toLowerCase()) {
            case "start":
                return <Icon as={FaArrowAltCircleRight} color="green.500" boxSize={6} _hover={{ color: "green.500" }} />;
            case "info":
                return <Icon as={BsFillInfoCircleFill} color="blue.500" boxSize={5} _hover={{ color: "blue.500" }} />;
            case "ok":
                return <Icon as={FaFlagCheckered} color="green.400" _hover={{ color: "green.400" }} />;
            case "warning":
                return <Icon as={AiFillWarning} color="orange.500" _hover={{ color: "orange.500" }} />;
            case "error":
                return <Icon as={AiFillCloseCircle} color="red.500" _hover={{ color: "red.500" }} />;
            default:
                return null;
        }
    };

    const fetchUploadStatusRefresh = async () => {
        try {
            setSpinnerLoading(true);
            const richiesta = {
                BearerToken: sessionStorage.getItem("token"),
                username: sessionStorage.getItem("username"),
                //caseType: CASE_TYPE.CATALOG_ALL,
            }
            const options = {

                headers: {
                    'Content-Type': 'application/json',
                }
            }

            const urlFetch = `${react_api}/statusCatalogue/getStatusTablesADP`;

            const response = await axiosInstance.post(urlFetch, richiesta, options)

            const result = response.data;
            if (response.status.toString() === HTTP_STATUS_CODES.BAD_REQUEST || response.status.toString() === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
                toast({
                    title: t('toastMsg.error'),
                    description: t(`messageBE.${result.message}`),
                    position: "top",
                    status: 'error',
                    duration: 4000,
                    isClosable: true
                });
            }
            if (response.status.toString() === HTTP_STATUS_CODES.OK) {
                setUploadStatus(result.status_tables);
            }
            else {

                setMessage(response.message);
            }
        } catch (error) {
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                position: "top",
                status: 'warning',
                duration: 4000,
                isClosable: true
            });
        }finally{
            setSpinnerLoading(false);
        }
    };

    useEffect(() => {

        const fetchUploadStatus = async () => {
            try {

                const richiesta = {
                    BearerToken: sessionStorage.getItem("token"),
                    username: sessionStorage.getItem("username"),
                    //caseType: CASE_TYPE.CATALOG_ALL,
                }
                const options = {

                    headers: {
                        'Content-Type': 'application/json',
                    }
                }

                const urlFetch = `${react_api}/statusCatalogue/getStatusTablesADP`;

                const response = await axiosInstance.post(urlFetch, richiesta, options)

                const result = response.data;
                if (response.status.toString() === HTTP_STATUS_CODES.BAD_REQUEST || response.status.toString() === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t(`messageBE.${result.message}`),
                        position: "top",
                        status: 'error',
                        duration: 4000,
                        isClosable: true
                    });
                }
                if (response.status.toString() === HTTP_STATUS_CODES.OK) {
                    setUploadStatus(result.status_tables);
                }
                else {

                    setMessage(response.message);
                }
            } catch (error) {
                toast({
                    title: t('toastMsg.callError'),
                    description: String(error),
                    position: "top",
                    status: 'warning',
                    duration: 4000,
                    isClosable: true
                });
            }
        };

        fetchUploadStatus();
    }
        , []);

    useEffect(() => {
        const refreshInterval = timer_refresh_upload_status || 3000;
        const intervalId = setInterval(() => {
            fetchUploadStatusRefresh();
        }, refreshInterval);
    
        return () => clearInterval(intervalId);
    }, []);

    return (

        <Box h="99%" w="100%" display="flex" flexDirection="column">
            <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}>
                <Heading size='xl' color={"rgba(11,78,90,255)"} >{t('statusInformation.uploadStatus')}</Heading>{/*Upload Status / Stato Caricamenti*/}
                <Tooltip label={t('toolTip.tooltipStatusInfo.manualRefresh')} placement="right" closeOnClick={true}>
                    <span>
                        <Button
                            isLoading={spinnerLoading}
                            colorScheme="blue"
                            onClick={fetchUploadStatusRefresh}
                            data-testid="refresh-button"
                            mr="4"
                        >
                            {t('statusInformation.refresh')}
                        </Button>
                    </span>
                </Tooltip>
            </Box>
            <Box overflowY="auto" flex="1" h="100vh" boxShadow="lg" mt="4" ml="4" mr="4">

                <Table size="md" variant='striped' bgcolor="white">
                    <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={0}>
                        <Tr>
                            <Th color={"white"} width="5%"> {t('statusInformation.icon')}</Th> {/*Upload Status / Stato Caricamenti*/}
                            <Th color={"white"} width="25%"> {t('statusInformation.fileName')}</Th> {/*Upload Status / Stato Caricamenti*/}
                            <Th color={"white"} width="15%"> {t('statusInformation.lastUpdate')}</Th>
                            <Th color={"white"} width="10%"> {t('statusInformation.statusCode')}</Th>
                            <Th color={"white"} width="45%"> {t('statusInformation.message')}</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {uploadStatus.length > 0 ? (
                            (uploadStatus.map((item, index) => (
                                <Tr key={index}>
                                    <Td>{getStatusIcon(item.status_code)}</Td>
                                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                                        {item.filename}
                                    </Td>
                                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                                        {item.lastupdate.split('.')[0]}
                                    </Td>
                                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                                        {item.status_code}
                                    </Td>
                                    <Td>
                                        <Text
                                            noOfLines={2}
                                            width="100%"
                                        >
                                            {item.message}
                                        </Text>
                                    </Td>
                                </Tr>
                            )))) : (
                            <Tr alignContent={"center"}>
                                <Text
                                    fontSize={"lg"} color="rgba(11,78,90,255)">
                                    {message}
                                </Text>
                            </Tr>)}

                    </Tbody>
                </Table>

            </Box>
        </Box>

    )

}